export const ChannelTypes = [
  'TRAVELAGENT',
  'GDS',
  'COMPANY',
  'WHITELABEL',
  'CENTRALRESERVATIONOFFICE',
  'WBS',
  'HOTELRESERVATIONOFFICE',
  'DMO',
  'METASEARCH'
]

export const BookingActionTypes = [
  'Reserve',
  'OptionReserve',
  'Modify',
  'Cancel'
]
